import { jsx as _jsx } from "react/jsx-runtime";
import { SkeletonInfo } from '../skeleton';
import s from './country-skeleton.module.scss';
export const CountrySkeleton = () => (_jsx("div", { className: s.loader, children: _jsx(SkeletonInfo, { height: "60" }) }));
